import React, { useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Form from './Form'

const Drawer = ({ fullscreen, toggleFullscreen, horizontal, ...props }) => {
  const [ opacity, setOpacity ] = useState(0)
  const [ loaded, setLoaded ] = useState(false)
  const [ open, setOpen ] = useState(false)

  const frame = useRef()

  useEffect(() => {
    let timeout
    const handleMouseEvents = () => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        setOpacity(0)
        document.querySelector('.root').style.cursor = 'none'
      }, 2000)
      setOpacity(1)
      document.querySelector('.root').style.cursor = ''
    }

    addEventListener('click', handleMouseEvents)
    addEventListener('mousemove', handleMouseEvents)

    return () => {
      clearTimeout(timeout)
      removeEventListener('click', handleMouseEvents)
      removeEventListener('mousemove', handleMouseEvents)
    }
  }, [])

  return (
    <>
      <div
        className="overlay rounded-3 p-1 d-grid gap-1"
        style={{
          opacity,
          transition: 'opacity 0.3s',
          pointerEvents: opacity ? 'auto' : 'none',
          gridTemplateColumns: horizontal ? 'auto auto' : '',
        }}
      >
        <button
          type="button"
          className="btn btn-sm btn-light text-start"
          onClick={() => setOpen(open => !open)}
        >
          <FontAwesomeIcon
            icon="cog"
            className="me-1"
            fixedWidth
          />
          Settings
        </button>

        {
          document.fullscreenEnabled &&
          <button
            type="button"
            className="btn btn-sm btn-light text-start"
            onClick={toggleFullscreen}
          >
            <FontAwesomeIcon
              icon={fullscreen ? 'compress' : 'expand'}
              className="me-1"
              fixedWidth
            />
            Fullscreen
          </button>
        }
      </div>

      <div
        className="position-fixed top-0 start-0 w-100 h-100 overlay"
        style={{
          WebkitBackdropFilter: 'none',
          backdropFilter: 'none',
          opacity: Number(open),
          transition: 'opacity 0.5s',
          pointerEvents: open ? 'auto' : 'none',
          zIndex: 99,
        }}
        onClick={() => setOpen(false)}
      ></div>

      <div
        className="position-fixed top-0 start-0 h-100"
        style={{
          translate: `${open ? '0' : '-100%'} 0`,
          transition: 'translate 0.5s',
          zIndex: 100,
        }}
      >
        <iframe
          ref={frame}
          src={location.pathname + '/edit'}
          className="h-100 border-0 bg-white" // fix weird scrolling in iPadOS
          style={{ width: '416px', maxWidth: '100vw' }}
          onLoad={() => setLoaded(true)}
        />
        {loaded && createPortal(
          <div className="p-5">
            <div className="position-relative">
              <button
                className="btn-close position-absolute end-0"
                aria-label="Close"
                onClick={() => setOpen(false)}
              ></button>
              <Form {...props} />
            </div>
          </div>,
          frame.current.contentWindow.document.body
        )}
      </div>
    </>
  )
}

export default Drawer
